// import React from 'react';
// // import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import { render } from 'react-dom';



// // const {MyModule} = require('./MyModule');

// render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
// // // If you want to start measuring performance in your app, pass a function
// // // to log results (for example: reportWebVitals(console.log))
// // // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// // import React from 'react';
// // import { render } from 'react-dom';
// // import App from './App';
// // import reportWebVitals from './reportWebVitals';
// // import './index.css';

// // render(
// //     <App />,
// //     document.getElementById('root')
// // );
// reportWebVitals();
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";


// const ele=<App/>
// React.PureComponent(
//  <App/>,
  
   
//   document.getElementById('root')
// );
ReactDOM.render(
    
      <App />
    ,
    document.getElementById('root')
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

